import type { IconProps } from './IconLibrary';

function VegetablePatchIcon({ size = 40, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" {...props}>
      <rect
        x="5"
        y="14"
        width="30"
        height="20"
        rx="2"
        fill="#8a6642"
        stroke="#2f2f2f"
        strokeWidth="1.5"
      />
      <path d="M5 20 H35 M5 26 H35" stroke="#6b4d30" strokeWidth="1.2" />
      <g stroke="#2f2f2f" strokeWidth="1" strokeLinecap="round">
        <path d="M11 17 v-5 M11 17 l-2 -3 M11 17 l2 -3" fill="none" stroke="#5c9e5c" />
        <path d="M20 23 v-5 M20 23 l-2 -3 M20 23 l2 -3" fill="none" stroke="#5c9e5c" />
        <path d="M29 17 v-5 M29 17 l-2 -3 M29 17 l2 -3" fill="none" stroke="#5c9e5c" />
      </g>
    </svg>
  );
}

export default VegetablePatchIcon;
